export const mergeClasses = (...args) => Object.assign({}, ...args);